import { Box, Stack, Typography } from '@mui/material';

export const BulletItem = ({
  title,
  leftContent,
  rightContent,
}: {
  title: string;
  leftContent: React.ReactNode;
  rightContent?: React.ReactNode;
}) => {
  return (
    <Stack
      width='100%'
      direction='row'
      gap='100px'
      justifyContent='space-between'
    >
      <Stack gap='24px'>
        <Typography variant='body1'>{title}</Typography>
        <Box width='440px'>{leftContent}</Box>
      </Stack>
      <Box width='50%'>{rightContent}</Box>
    </Stack>
  );
};
